module.exports = __webpack_public_path__ + "static/media/skincarepro_score_percentile.d8de6f67.png";